import { Stack as MuiStack, type StackProps } from '@mui/material';

export function Stack({ children, ...props }: StackProps) {
  return (
    <MuiStack flexWrap={props.direction === 'row' ? 'wrap' : undefined} {...props}>
      {children}
    </MuiStack>
  );
}
